import {useAuth} from "@komune-io/g2-providers";

export const LogoutPage = () => {
  const {keycloak} = useAuth();
  keycloak.logout()
  return (
   <div></div>
  );
}
